import { Segment } from 'semantic-ui-react';

export default Segment;
